import React from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Typography, Popper, Fade, Box, ClickAwayListener } from "@material-ui/core"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	paper: {
		border: `0.5px solid ${theme.palette.grey["100"]}`,
		backgroundColor: theme.palette.background.paper,
		padding: "8px 42px 8px 8px",
		marginTop: 4,
	},
}))

function TagMenuPoper({ menuData, anchorEl, handleClickAway }) {
	const classes = useStyles()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const open = Boolean(anchorEl)
	const id = open ? menuData?.tag_id : undefined

	return (
		<ClickAwayListener onClickAway={handleClickAway}>
			<Popper id={id} open={open} anchorEl={anchorEl} transition>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<Box className={classes.paper}>
							<Typography
								variant="body1"
								style={{ fontSize: theme.typography.fontSize, fontWeight: theme.typography.fontWeightMedium }}
							>
								{t("tag.appliedBy")}
							</Typography>
							<Typography variant="body2">{menuData?.name}</Typography>
						</Box>
					</Fade>
				)}
			</Popper>
		</ClickAwayListener>
	)
}

export default TagMenuPoper
